module.exports = __webpack_public_path__ + "img/codeBG.b81490ac.png";